
import React, { useContext, useEffect } from "react";
import "../Navbar/Navbar.scss";
import "../Sidebar/Sidebar.scss";
import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import brand from "../../../Assets/Images/brand-logo.svg";
import "../Sidebar/responsiveSidebar.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import { API_BASE_URL } from "../../../utils/index";
import DashBoardIteams from "../../SidebarItems/DashBoardIteams";
import ProductsItems from "../../SidebarItems/ProductsItems";
import CouponItems from "../../SidebarItems/CouponItems";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShippingItems from "../../SidebarItems/ShippingItems";
import MasterItems from "../../SidebarItems/MasterItems";
import userContext from "../../UseContext/UseContext";
import Notification from "./Notification";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import PeopleIcon from "@mui/icons-material/People";
import VendorItems from "../../SidebarItems/VendorItems";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { Collapse, Nav } from "react-bootstrap";
const SidebarItem = ({ icon, text, link, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="text-decoration-none">
      <li
        onClick={() => setIsOpen(!isOpen)}
        aria-controls={text}
        aria-expanded={isOpen}
      >
        <div className="d-flex ">
          <span className="me-2">{icon} </span>
          <div className="sidebar-text text-center my-auto">{text}</div>
        </div>
        {isOpen ? (
          <IoIosArrowDown className="sidebar-menu-icon" />
        ) : (
          <IoIosArrowForward className="sidebar-menu-icon" />
        )}
      </li>

      <Collapse in={isOpen}>
        <div id={text}>{children}</div>
      </Collapse>
    </div>
  );
};
const Navbar = ({ handleClick, orders, users, inquiries }) => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [menuOpen, setmenuOpen] = useState(false);
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();

  const { logOutContext, subdomain, permissionvalues } =
    useContext(userContext);

  const permissionforprofile =
    permissionvalues?.permissions?.dashboard?.profile;
  const vendorsubdomain = localStorage.getItem("vendorsubdomain");
  useEffect(() => {
    const adminId = localStorage.getItem("adminId");
    const vendorsccesstoken = localStorage.getItem("vendorsccesstoken");

    const isAdminIdValid =
      adminId && adminId !== "null" && adminId !== "undefined";
    const isVendorTokenValid =
      vendorsccesstoken &&
      vendorsccesstoken !== "null" &&
      vendorsccesstoken !== "undefined";

    // if (!isAdminIdValid && !isVendorTokenValid) {
    //   navigate(vendorsubdomain ? `/${vendorsubdomain}/login` : "/login");
    // }

    const headers = {
      Authorization: `Bearer ${adminId}`,
      "Content-Type": "application/json",
    };

    axios
      .get(`${API_BASE_URL}/admin/profile`, {
        headers,
      })
      .then((result) => {
        setProduct(result?.data?.admin);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          // navigate("/login");
        }
      });
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("adminId");
    // logOutContext?.setLogOut(true);
    navigate(vendorsubdomain ? `/${vendorsubdomain}/login` : "/login");
  };

  const permissionsData = permissionvalues?.permissions || {};
  const subdoamin = localStorage.getItem("vendorsubdomain");

  const hasAnyPermission = (section, subSection = null) => {
    if (!permissionsData[section]) return false;

    if (subSection) {
      const subsectionData = permissionsData[section][subSection];
      return (
        subsectionData?.create ||
        subsectionData?.edit ||
        subsectionData?.read ||
        subsectionData?.delete
      );
    }

    const sectionData = permissionsData[section];

    if (
      sectionData.create ||
      sectionData.edit ||
      sectionData.read ||
      sectionData.delete
    ) {
      return true;
    }

    if (typeof sectionData === "object") {
      return Object.values(sectionData).some(
        (perm) => perm?.create || perm?.edit || perm?.read || perm?.delete
      );
    }

    return false;
  };

  return (
    <div className="dashboard-nav px-4">
      <div className="nav-menu">
        <svg
          onClick={handleClick}
          className="fs-5"
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
        </svg>
      </div>

      <div className="responsive-sidebar">
        <svg
          onClick={handleShow}
          className="fs-5"
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
        </svg>
        <Offcanvas show={show} onHide={handleClose} backdrop="static">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="text-dark"></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="text-danger">
            <img
              src={brand}
              alt="brand_logo"
              className="responsive-sidebar-logo"
            />



            <ul className="sidebar-items">
              {subdoamin === id ? (
                <>
                  {hasAnyPermission("dashboard") && (
                    <SidebarItem
                      icon={<DashboardIcon className="sidebar-icon" />}
                      text="Dashboard"
                    >
                      {permissionsData.dashboard.dashboard &&
                        (permissionsData.dashboard.dashboard.create ||
                          permissionsData.dashboard.dashboard.edit ||
                          permissionsData.dashboard.dashboard.read ||
                          permissionsData.dashboard.dashboard.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/dashboard`}
                          >
                            <li className="mx-2">Main Dashboard</li>
                          </Link>
                        )}

                      {permissionsData.dashboard.enquiry &&
                        (permissionsData.dashboard.enquiry.create ||
                          permissionsData.dashboard.enquiry.edit ||
                          permissionsData.dashboard.enquiry.read ||
                          permissionsData.dashboard.enquiry.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/dashboard/enquiry`}
                          >
                            <li className="mx-2">Enquiries</li>
                          </Link>
                        )}
                      {permissionsData.dashboard.user &&
                        (permissionsData.dashboard.user.create ||
                          permissionsData.dashboard.user.edit ||
                          permissionsData.dashboard.user.read ||
                          permissionsData.dashboard.user.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/dashboard/user`}
                          >
                            <li className="mx-2">Users</li>
                          </Link>
                        )}
                      {permissionsData.dashboard.totalOrder &&
                        (permissionsData.dashboard.totalOrder.create ||
                          permissionsData.dashboard.totalOrder.edit ||
                          permissionsData.dashboard.totalOrder.read ||
                          permissionsData.dashboard.totalOrder.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/dashboard/total-order`}
                          >
                            <li className="mx-2">Total Orders</li>
                          </Link>
                        )}
                    </SidebarItem>
                  )}

                  {/* Products */}
                  {permissionsData?.product?.products &&
                    (permissionsData.product.products.create ||
                      permissionsData.product.products.edit ||
                      permissionsData.product.products.read ||
                      permissionsData.product.products.delete) && (
                      <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                        <Nav.Link
                          as={Link}
                          to={`/${subdoamin}/products`}
                          className="d-flex p-2 text-black"
                        >
                          <ShoppingBasketIcon className="sidebar-icon me-2" />
                          <span className="sidebar-text my-auto">Products</span>
                        </Nav.Link>
                      </Nav.Item>
                    )}

                  {/* Coupons */}
                  {permissionsData?.coupon?.coupons &&
                    (permissionsData.coupon.coupons.create ||
                      permissionsData.coupon.coupons.edit ||
                      permissionsData.coupon.coupons.read ||
                      permissionsData.coupon.coupons.delete) && (
                      <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                        <Nav.Link as={Link} to={`/${subdoamin}/coupons`} className="p-2 text-black">
                          <LocalOfferIcon className="sidebar-icon me-2" />
                          <span className="sidebar-text">Coupons</span>
                        </Nav.Link>
                      </Nav.Item>
                    )}

                  {/* Shipping */}
                  {permissionsData?.shipping?.shipping &&
                    (permissionsData.shipping.shipping.create ||
                      permissionsData.shipping.shipping.edit ||
                      permissionsData.shipping.shipping.read ||
                      permissionsData.shipping.shipping.delete) && (
                      <Nav.Item as="li" className="sidebar-item ml-auto p-0">
                        <Nav.Link as={Link} to={`/${subdoamin}/shipping`} className="p-2 text-black">
                          <LocalShippingIcon className="sidebar-icon me-2" />
                          <span className="sidebar-text">Shipping</span>
                        </Nav.Link>
                      </Nav.Item>
                    )}

                  {/* Master dropdown */}
                  {hasAnyPermission("master") && (
                    <SidebarItem
                      icon={<SettingsApplicationsIcon className="sidebar-icon" />}
                      text="Master"
                    >
                      {permissionsData.master.category &&
                        (permissionsData.master.category.create ||
                          permissionsData.master.category.edit ||
                          permissionsData.master.category.read ||
                          permissionsData.master.category.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/category`}
                          >
                            <li className="mx-2">Category</li>
                          </Link>
                        )}
                      {permissionsData.master.subCategory &&
                        (permissionsData.master.subCategory.create ||
                          permissionsData.master.subCategory.edit ||
                          permissionsData.master.subCategory.read ||
                          permissionsData.master.subCategory.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/sub-category`}
                          >
                            <li className="mx-2">Sub Category</li>
                          </Link>
                        )}
                      {permissionsData.master.blog &&
                        (permissionsData.master.blog.create ||
                          permissionsData.master.blog.edit ||
                          permissionsData.master.blog.read ||
                          permissionsData.master.blog.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/blog`}
                          >
                            <li className="mx-2">Blog</li>
                          </Link>
                        )}
                      {permissionsData.master.description &&
                        (permissionsData.master.description.create ||
                          permissionsData.master.description.edit ||
                          permissionsData.master.description.read ||
                          permissionsData.master.description.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/description-name`}
                          >
                            <li className="mx-2">Description Name</li>
                          </Link>
                        )}
                      {permissionsData.master.descriptionType &&
                        (permissionsData.master.descriptionType.create ||
                          permissionsData.master.descriptionType.edit ||
                          permissionsData.master.descriptionType.read ||
                          permissionsData.master.descriptionType.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/description-type`}
                          >
                            <li className="mx-2">Description Type</li>
                          </Link>
                        )}


                      {permissionsData.master.filter &&
                        (permissionsData.master.filter.create ||
                          permissionsData.master.filter.edit ||
                          permissionsData.master.filter.read ||
                          permissionsData.master.filter.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`/${subdoamin}/master/filter`}
                          >
                            <li className="mx-2">Filter</li>
                          </Link>
                        )}
                      {permissionsData.master.filterType &&
                        (permissionsData.master.filterType.create ||
                          permissionsData.master.filterType.edit ||
                          permissionsData.master.filterType.read ||
                          permissionsData.master.filterType.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`${subdoamin}/master/filter-type`}
                          >
                            <li className="mx-2">Filter Type</li>
                          </Link>
                        )}
                      {permissionsData.master.offerPoster &&
                        (permissionsData.master.offerPoster.create ||
                          permissionsData.master.offerPoster.edit ||
                          permissionsData.master.offerPoster.read ||
                          permissionsData.master.offerPoster.delete) && (
                          <Link
                            className="text-dark text-decoration-none"
                            style={{ fontSize: "13px" }}
                            to={`${subdoamin}/master/offer-poster`}
                          >
                            <li className="mx-2">Offer Poster</li>
                          </Link>
                        )}
                    </SidebarItem>
                  )}

                </>
              ) : (
                <>
                  <DashBoardIteams />
                  <ProductsItems />
                  <CouponItems />
                  <ShippingItems />
                  <MasterItems />
                  <VendorItems />

                </>
              )}

              {/* <Export/>  */}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <div className="d-flex align-iteam-center">
        <Link to="/profilepage" className="user">
          {/* <img className="user-image mx-2" src={userImage} /> */}
        </Link>

        <Dropdown className="user">
          <Dropdown.Toggle
            id="dropdown-button-dark-example1"
          // variant="secondary"
          >
            <div className="user-name">
              {permissionvalues
                ? permissionvalues?.email
                : product?.name || "Loading..."}
            </div>
            <CgProfile className="mx-2 text-dark fs-4" />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {vendorsubdomain === id ? (
              permissionforprofile?.read && (
                <Dropdown.Item href={`/${vendorsubdomain}/profile`}>
                  Profile Page
                </Dropdown.Item>
              )
            ) : (
              <Dropdown.Item href="/profilepage">Profile Page</Dropdown.Item>
            )}

            <Dropdown.Divider />
            <div className="w-100 d-flex align-items-center justify-content-center">
              <button
                className="py-1 px-2 rounded  logout"
                onClick={handleLogout}
              >
                Log Out
              </button>
            </div>
          </Dropdown.Menu>
        </Dropdown>
        <Notification orders={orders} users={users} inquiries={inquiries} />
      </div>
    </div>
  );
};

export default Navbar;
